import BillingsOrderRailyTaxiRecalculateParams, {
  BillingsOrderRailyTaxiRecalculateParamsBillingNode,
  BillingsOrderRailyTaxiRecalculateParamsBonusType,
  BillingsOrderRailyTaxiRecalculateParamsPenaltyType,
} from "../../../../../common/services/billings/order/raily-taxi/recalculate/billings-order-raily-taxi-recalculate-params";
import BillingsNode from "../../../common/types/billings-node";
import BillingFormData from "../types/billing-form.data";
import BonusType from "../types/bonus-type";
import PenaltyType from "../types/penalty-type";

const createBillingNode = (
  node: BillingsNode,
): BillingsOrderRailyTaxiRecalculateParamsBillingNode => {
  return {
    uuid: node.id,
    nodeUuid: node.nodeId,
    orderUuid: node.orderId ?? undefined,
    lat: node.lat,
    lon: node.lon,
    distance: node.distance,
    description: node.description,
    checkoutDate: node.checkoutDate ?? undefined,
    checkoutEventUuid: node.checkoutEventUuid ?? undefined,
    plannedDate: node.plannedDate ?? undefined,
    haltingTime: node.haltingTime,
    allowCharge: node.isHighwayAllowed,
    highwayCharge: node.highwayCharge,
    plannedDistance: node.plannedDistance,
    editableCoordinates: node.isEditable,
  };
};

const createBillingNodes = (
  nodes: BillingsNode[],
): BillingsOrderRailyTaxiRecalculateParamsBillingNode[] => {
  return nodes.map(createBillingNode);
};

const createBonusType = (
  bonusType: BonusType | undefined,
): BillingsOrderRailyTaxiRecalculateParamsBonusType | undefined => {
  switch (bonusType) {
    case BonusType.DISTANCE_RATE_CHANGED:
      return BillingsOrderRailyTaxiRecalculateParamsBonusType.DISTANCE_RATE_CHANGED;
    case BonusType.HALTING_RATE_CHANGED:
      return BillingsOrderRailyTaxiRecalculateParamsBonusType.HALTING_RATE_CHANGED;
    case BonusType.OTHER:
      return BillingsOrderRailyTaxiRecalculateParamsBonusType.OTHER;
    case BonusType.SHORT_ROUTE:
      return BillingsOrderRailyTaxiRecalculateParamsBonusType.SHORT_ROUTE;
  }
};

const createPenaltyType = (
  penaltyType: PenaltyType | undefined,
): BillingsOrderRailyTaxiRecalculateParamsPenaltyType | undefined => {
  switch (penaltyType) {
    case PenaltyType.BEING_LATE:
      return BillingsOrderRailyTaxiRecalculateParamsPenaltyType.BEING_LATE;
    case PenaltyType.GUIDELINE_IGNORED:
      return BillingsOrderRailyTaxiRecalculateParamsPenaltyType.GUIDELINE_IGNORED;
    case PenaltyType.HIGHWAY_NOT_ALLOWED:
      return BillingsOrderRailyTaxiRecalculateParamsPenaltyType.HIGHWAY_NOT_ALLOWED;
    case PenaltyType.INCOMPATIBLE_CAR:
      return BillingsOrderRailyTaxiRecalculateParamsPenaltyType.INCOMPATIBLE_CAR;
    case PenaltyType.OPTIMIZATION_REFUSED:
      return BillingsOrderRailyTaxiRecalculateParamsPenaltyType.OPTIMIZATION_REFUSED;
    case PenaltyType.OTHER:
      return BillingsOrderRailyTaxiRecalculateParamsPenaltyType.OTHER;
    case PenaltyType.SUBOPTIMAL_RIDE:
      return BillingsOrderRailyTaxiRecalculateParamsPenaltyType.SUBOPTIMAL_RIDE;
    default:
      return undefined;
  }
};

const createRecalculateRequest = (
  orderUuid: string,
  data: BillingFormData,
): BillingsOrderRailyTaxiRecalculateParams => {
  const result: BillingsOrderRailyTaxiRecalculateParams = {
    orderUuid: orderUuid,
    billingNodes: createBillingNodes(data.billingNodes),
    bonus: data.bonus,
    penalty: data.penalty,
    bonusType: createBonusType(data.bonusType),
    penaltyType: createPenaltyType(data.penaltyType),
  };
  return result;
};

const billingRecalculateRequestFactory = {
  createRecalculateRequest,
};

export default billingRecalculateRequestFactory;
